import { render, staticRenderFns } from "./TemplateTheme.vue?vue&type=template&id=aae8c1ee"
import script from "./TemplateTheme.vue?vue&type=script&lang=js"
export * from "./TemplateTheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports